const { ConsentManager } = require('./entities/consent-manager')
const { PrivacyController } = require('./external/privacy-controller')
const { errorMessages } = require('./const/error-messages')

class SDKPrivacy {
  constructor(stage = 'prd') {
    this.listOfHash = []
    this.holder = {}
    this.consentMetadata = []
    this.termsOfUseHash = ConsentManager.getTermsOfUseHash()
    this.privacyPolicyHash = ConsentManager.getPrivacyPolicyHash()
    this.promotionOffersHash = ConsentManager.getPromotionOffersHash()
    this.subscriptionContractHash = ConsentManager.getSubscriptionContractHash()
    this.stage = stage
  }
  
  /**
   * {
   *   name: '',
   *   email: '',
   *   document: '',
   *   phone: ''
   * }
   * @param {object} holder 
   */
  addHolder(holder) {
    this.holder = holder
  }

  addConsentMetadata(consentMetadata) {
    this.consentMetadata = consentMetadata
  }

  /**
   * Add one or a list of hash\'s
   * @param {string|array} hash
   * @returns void
   */
  addHash(hash) {
    if (!hash) {
      throw new Error(errorMessages.hashRequiredValid)
    }

    if (Array.isArray(hash)) {
      this.listOfHash = [...this.listOfHash, ...hash]
      return
    }

    this.listOfHash.push(hash)
  }

  clearHash() {
    this.listOfHash = []
  }

  async consent(consent) {
    this.listOfHash.forEach(async (hash) => {
      await PrivacyController.sendConsent(this.stage, hash, consent, {
        consentMetadata: this.consentMetadata,
        holder: this.holder
      })
    })
  }
}

module.exports.SDKPrivacy = SDKPrivacy
